/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export interface DesktopWindowHistoryEntry {
  key: string;
  path: string;
  state?: unknown;
}

/** Navigation stack of one tab; paths and current index survive session restoration. */
export interface DesktopWindowHistory {
  entries: DesktopWindowHistoryEntry[];
  index: number;
}

export const MAX_WINDOW_HISTORY_ENTRIES = 50;

let historyKeyCounter = 0;
export const createHistoryEntry = (path: string, state?: unknown): DesktopWindowHistoryEntry => {
  historyKeyCounter += 1;
  return { key: `w${historyKeyCounter.toString(36)}`, path, state };
};
export const createHistory = (path: string, state?: unknown): DesktopWindowHistory => ({
  entries: [createHistoryEntry(path, state)],
  index: 0,
});

/** Restores a saved history (paths, oldest first) at `path`; a fresh one when it does not fit. */
export const restoreHistory = (
  path: string,
  paths: readonly string[] | undefined,
): DesktopWindowHistory => {
  const index = paths?.lastIndexOf(path) ?? -1;
  return paths && index !== -1
    ? { entries: paths.map((entryPath) => createHistoryEntry(entryPath)), index }
    : createHistory(path);
};

export const getCurrentHistoryEntry = (windowState: {
  history: DesktopWindowHistory;
  path: string;
}) =>
  windowState.history.entries[windowState.history.index] ?? {
    key: 'default',
    path: windowState.path,
  };
